export default class Line {
  constructor(source, target) {
    this.source = source
    this.target = target
  }

  toSVGCommand = () => {
    const source = this.source
    const target = this.target

    return `
      M ${source.x},${source.y}
      L ${source.x},${source.y}
        ${target.x},${target.y}
    `
  }

  isVertical = () => {
    /**
     *         × A (source.x, source.y)
     *           ∖
     *             ∖
     *               ∖
     *         ×       × B (target.x, target.y)
     *         C (source.x, target.y)
     *
     *  If the distance between A and C is longer than C to B the line will be "vertical"
     */

    return (
      Math.abs(this.target.y - this.source.y) >
      Math.abs(this.target.x - this.source.x)
    )
  }
}
